import React from "react";
import { CircleCheckBigIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/content";
type CtaButtonProps = {
  label: string;
  sub?: string;
  id?: string;
  tone?: "light" | "dark";
};
export function CtaButton({
  label,
  sub,
  id,
  tone = "light"
}: CtaButtonProps) {
  const handleClick = () => {
    window.fbq?.("track", "InitiateCheckout");
  };
  return <div id={id} className="mx-auto flex w-full max-w-xl flex-col items-center" data-id="element-99" data-mp="qkk4emsyqywf">
      <a href={CHECKOUT_URL} onClick={handleClick} className="animate-cta-pulse group flex w-full items-center justify-center gap-3 rounded-2xl bg-go px-5 py-5 text-center text-[17px] font-extrabold uppercase leading-snug tracking-wide text-white transition-[transform,background-color] duration-150 ease-out hover:bg-go-dark active:scale-[0.98] focus:outline-none focus-visible:ring-4 focus-visible:ring-go/40 md:text-xl" data-id="element-100" data-mp="qi7g7rwm3sax">
        <CircleCheckBigIcon className="h-6 w-6 shrink-0" aria-hidden data-id="element-101" data-mp="15ahrt0j2jkkk" />
        <span data-id="element-102" data-mp="35xo0oxojy8ky">{label}</span>
      </a>
      {sub && <p className={`mt-3 text-center text-sm ${tone === "dark" ? "text-plum-100" : "text-ink/60"}`} data-id="element-103" data-mp="35yz3au69haah">
          {sub}
        </p>}
    </div>;
}